import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { DropdownNavigation } from './DropdownNavigation';
import { Expander } from './Expander';
import { Logo } from './Logo';
import { Navigation } from './Navigation';
import { useAnimationSidePanelState } from './useAnimationSidePanelState';

import { useSidebar } from '@/app/context/SidebarContext/SidebarContext';

export const Sidebar = () => {
	const { ref } = useSidebar();

	return (
		<>
			<Expander containerRef={ref}>
				<Logo />
				<Navigation />
				<DropdownNavigation />
			</Expander>
		</>
	);
};

interface SidePanelWindowProps {
	isOpen: boolean;
	children?: React.ReactNode;
}

export const SidePanelMenu = (props: SidePanelWindowProps) => {
	const { ref } = useSidebar();
	// eslint-disable-next-line react-hooks/refs
	const [element, setElement] = useState<HTMLDivElement | null>(ref.current);

	useLayoutEffect(() => {
		setElement(ref.current);
	}, [ref]);

	if (!element) {
		return null;
	}

	return createPortal(<SidePanelWindow {...props} />, element);
};

export const SidePanelWindow = ({ isOpen, children }: SidePanelWindowProps) => {
	const { ref, isVisible } = useAnimationSidePanelState(isOpen);

	return (
		<>
			{isVisible && (
				<div
					ref={ref}
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						height: '100%',
						width: '100%',
						background: '#fff',
					}}
				>
					{children}
				</div>
			)}
		</>
	);
};
